import React, {useState} from 'react';
import Title from './sections/Title';
import Message from './sections/Message';
import Introduction from './sections/Introduction';
import Estates from './sections/Estates';
import Ratios from './sections/Ratios';
import NewsLetter from './sections/NewsLetter';
import Links from './sections/Links';
import { createEstate } from './models';

const ESTATES_SECTION_ID = 'estates';

function App() {
  const [isAgreedWith, setIsAgreedWith] = useState(false);
  const [estates, setEstates] = useState<Estate[]>(() => [createEstate()]);

  return (
    <main>
      <Title linkTargetId={ESTATES_SECTION_ID} isAgreedWith={isAgreedWith} setIsAgreedWith={setIsAgreedWith} />
      <Message />
      <Introduction linkTargetId={ESTATES_SECTION_ID} isAgreedWith={isAgreedWith} setIsAgreedWith={setIsAgreedWith} />
      {isAgreedWith && (
        <>
          <Estates id={ESTATES_SECTION_ID} estates={estates} setEstates={setEstates} />
          <Ratios estates={estates} setEstates={setEstates} />
          <NewsLetter estates={estates} />
          <Links />
        </>
      )}
    </main>
  );
}

export default App;
